import { z } from 'zod'

export const formSchema = z.object({
  companyName: z.string().min(1, 'Company name is required'),
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().optional(),
})

export type SignupSuccessFormData = z.infer<typeof formSchema>

export interface User {
  id: string
  email: string | null
  first_name: string | null
  last_name: string | null
}

